import React from 'react'
import { useState } from 'react'
import { createURL, deepCopy, getRootURL } from '../../lib'
import SocketIOClient from 'socket.io-client'
import { tokenSilentlyOption } from '../../lib/Auth0'
import * as constants from '../../constants'
import { validate, validateType } from '../../lib/validator'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { types } from '../../constants/ActionTypes'
import { useReducer } from 'react'
import { useContext } from 'react'
import { SettingsContext } from '../../Parts/Settings'
import { useRef } from 'react'
import { useHistory } from 'react-router-dom'
import CryptoJS from 'crypto-js'

const CRYPT_KEY = '0ams2HBLb7zhFe5v79YqAhG0bnx4Nriu'

const validateProps = {
  [constants.gameType.LIVE_GAME]: [
    { name: 'groupName',      type: validateType.STRINGS, must: true  },
    { name: 'gameType',       type: validateType.STRINGS, must: true  },
    { name: 'openingRule',    type: validateType.STRINGS, must: true  },
    { name: 'title',          type: validateType.STRINGS, must: true, maxStringLength: 20, minStringLength: 0 },
    { name: 'minute',         type: validateType.INTEGER, must: true, maxValue: 60, minValue: 1 },
    { name: 'increaseSecond', type: validateType.INTEGER, must: true, maxValue: 60, minValue: 0 },
    { name: 'enableUndo',     type: validateType.BOOLEAN, must: true },
    { name: 'turnType',       type: validateType.STRINGS, must: true },
  ],
  [constants.gameType.DAILY_GAME]: [
    { name: 'groupName',      type: validateType.STRINGS, must: true },
    { name: 'gameType',       type: validateType.STRINGS, must: true },
    { name: 'openingRule',    type: validateType.STRINGS, must: true },
    { name: 'title',          type: validateType.STRINGS, must: true, maxStringLength: 20, minStringLength: 0 },
    { name: 'days',           type: validateType.INTEGER, must: true, maxValue: 90, minValue: 1 },
    { name: 'daysPerMove',    type: validateType.INTEGER, must: true, maxValue: 60, minValue: 1 },
  ],
}

const initialState = {
  diffTime: undefined,
  rooms: [],
  room: undefined,
  groups: [],
  group: undefined,
  selectedGroup: undefined,
  chat: { messages: [] },
  groupChat: [],
  requestPasswordDialog: {
    open: false
  }
}

const reducer = (state, action) => {
  switch (action.type) {
    case types.game.CONNECT:
      break
    case types.game.RECEIVE_SERVER_TIME:
      return {
        ...state,
        diffTime: action.data.serverTime !== undefined ?
          action.data.serverTime - Date.now() : state.diffTime
      }
    case types.game.RECEIVE_GROUPS:
      return {
        ...state,
        groups: action.data.groups,
        selectedGroup: state.selectedGroup === undefined ?
          action.data.groups[0].name : state.selectedGroup,
        diffTime: action.data.serverTime !== undefined ?
          action.data.serverTime - Date.now() : state.diffTime
      }
    case types.game.RECEIVE_GROUP: {
      return {
        ...state,
        group: action.data.group
      }
    }
    case types.game.RECEIVE_GAME_ROOMS:
      return {
        ...state,
        rooms: action.data.rooms,
        diffTime: action.data.serverTime !== undefined ?
          action.data.serverTime - Date.now() : state.diffTime
      }
    case types.game.RECEIVE_GAME_ROOM: {
      return {
        ...state,
        room: action.data.room,
        diffTime: action.data.serverTime !== undefined ?
          action.data.serverTime - Date.now() : state.diffTime
      }
    }
    case types.game.RECEIVE_CHAT_MESSAGE:
      return {
        ...state,
        chat: {
          messages: state.chat.messages.length > 0 ? state.chat.messages.concat([{ ...action.data }]) : [{ ...action.data }]
        },
        diffTime: action.data.serverTime !== undefined ?
          action.data.serverTime - Date.now() : state.diffTime
      }
    case types.game.RECEIVE_GROUP_CHAT_MESSAGE:
      return {
        ...state,
        groupChat: state.groupChat.concat([{ ...action.data }])
      }
    case types.game.MAKE_URL: {
      let newMessages = deepCopy(state.chat.messages)
      newMessages[action.id].url = action.url
      return {
        ...state,
        chat: {
          messages: newMessages
        }
      }
    }
    case types.game.REQUEST_PASSWORD:
      return {
        ...state,
        requestPasswordDialog: {
          ...state.requestPasswordDialog,
          open: true,
        }
      }
    case types.game.CLOSE_REQUEST_PASSWORD_DIALOG: {
      return {
        ...state,
        requestPasswordDialog: {
          ...state.requestPasswordDialog,
          open: false,
        }
      }
    }
    case types.gameRoom.CLEAR_CHAT:
      return { ...state, chat: { messages: [] } }
    case types.gameRoom.CLEAR_ROOM:
      return { ...state, room: undefined }
    case types.gameRoomListCard.CHANGED_GROUP:
      return { ...state, selectedGroup: action.group }
    default:
      break
  }
}

export const GameContext = React.createContext()

export const GameProvider = (props) => {
  const { children } = props
	
	const [isInitialized, setIsInitialized] = useState(false)
  const [socket, setSocket] = useState(undefined)
  const [urlGroupName, setUrlGroupName] = useState('')
  const [urlRoomName, setUrlRoomName] = useState('')
  const [openNewGameSettingsDialog, setOpenNewGameSettingsDialog] = useState(false)

	const renjuBoardCards = useSelector(state => state.renjuBoardCards)
  const authentication = useSelector(state => state.authentication)

  const [state, dispatch] = useReducer(reducer, initialState)

  const dispatchForRedux = useDispatch()

  const settingsContext = useContext(SettingsContext)

  const history = useHistory()

  const prevState = useRef(state)

	const changedGroup = (group) => {
		dispatch({ type: types.gameRoomListCard.CHANGED_GROUP, group })
  }
  
  const clearChat = () => {
    dispatch({ type: types.gameRoom.CLEAR_CHAT })
  }

  const clearRoom = () => {
    dispatch({ type: types.gameRoom.CLEAR_ROOM })
  }

  const init = () => {
		var newSocket
    if (socket) {
      return
    }
    if (!authentication.auth0) return
    authentication.auth0.isAuthenticated()
    .then(result => {
      if (result) {
        return authentication.auth0.getTokenSilently(tokenSilentlyOption)
      }
      else {
        return Promise.resolve(undefined)
      }
    })
    .then(accessToken => {
      if (accessToken) {
        newSocket = SocketIOClient.connect(`${getRootURL()}/game`, {
          query: `token=${accessToken}`
        })
      }
      else {
        newSocket = SocketIOClient.connect(`${getRootURL()}/game`)
			}
			setSocket(newSocket)
      newSocket.on('connect', data => {
        if (accessToken) {
          newSocket.emit('authenticate', { token: accessToken })
          .on('authenticated', () => {
            setSocket(newSocket)
          })
          .on('unauthorized', msg => {
          })
        }
        else {
          setSocket(newSocket)
          newSocket.emit('authenticated')
        }
        console.dir('connect')
      })
    })
  }

  const serverTime = () => {
    if (!socket) {
      return
    }
    socket.emit('server time')
  }

  const groupsList = () => {
    if (!socket) {
      return
    }
    socket.emit('groups')
  }

  const joinGroup = (groupName) => {
    if (!socket) {
      return
		}
    socket.emit('join group', { groupName })
  }

  const leaveGroup = (groupName) => {
    if (!socket) {
      return
    }
    socket.emit('leave group', { groupName })
  }

  const joinRoom = (groupName, roomName, password) => {
    var cipher

    if (password) {
      cipher = CryptoJS.AES.encrypt(password, CRYPT_KEY).toString()
    }
    if (!socket) {
      return
    }
    socket.emit('join room', { groupName, roomName, cipher })
  }

  const leaveRoom = (groupName, roomName) => {
    if (!socket) {
      return
    }
    socket.emit('leave room', { groupName, roomName })
  }

  const joinGame = (groupName, roomName) => {
    if (!socket) {
      return
    }
    socket.emit('join game', { groupName, roomName })
  }

  const leaveGame = (groupName, roomName) => {
    if (!socket) {
      return
    }
    socket.emit('leave game', { groupName, roomName })
  }

  const restartGame = (groupName, roomName) => {
    if (!socket) {
      return
    }
    socket.emit('restart game', { groupName, roomName })
  }

  const newGame = (groupName, roomName) => {
    if (!socket) {
      return
    }
    socket.emit('new game', { groupName, roomName })
  }

  const gameSettings = (settings) => {
    var data
    const { gameType } = settings
    if (false === validate(settings, validateProps[gameType])){
      console.dir('error')
      return
    }
    data = {}
    validateProps[gameType].forEach(prop => data[prop.name] = settings[prop.name])
    data.roomName = settings.roomName
    if (!socket) {
      return
    }
    socket.emit('game settings', data)
  }

  const resetGameSettings = (groupName, roomName) => {
    if (!socket) {
      return
    }
    socket.emit('reset game settings', { groupName, roomName })
  }

  const ready = (groupName, roomName, ready) => {
    if (!socket) {
      return
    }
    socket.emit('ready', { groupName, roomName, ready })
  }

  const createGameRoom = (settings) => {
    var data
    const { gameType } = settings
    if (false === validate(settings, validateProps[gameType])){
      return
    }
    data = {}
    validateProps[gameType].forEach(prop => data[prop.name] = settings[prop.name])
    if (!socket) {
      return
    }
    socket.emit('create game room', data)
  }

  const move = (groupName, roomName, moves) => {
    if (!socket) {
      return
    }
    socket.emit('move', { groupName, roomName, moves })
  }

  const resign = (groupName, roomName) => {
    if (!socket) {
      return
    }
    socket.emit('resign', { groupName, roomName })
  }

  const offerDraw = (groupName, roomName) => {
    if (!socket) {
      return
    }
    socket.emit('offer draw', { groupName, roomName })
  }

  const acceptDraw = (groupName, roomName) => {
    if (!socket) {
      return
    }
    socket.emit('accept draw', { groupName, roomName })
  }

  const denyDraw = (groupName, roomName) => {
    if (!socket) {
      return
    }
    socket.emit('deny draw', { groupName, roomName })
  }

  const offerUndo = (numberOfUndo, groupName, roomName) => {
    if (!socket) {
      return
    }
    socket.emit('offer undo', { numberOfUndo, groupName, roomName })
  }

  const acceptUndo = (groupName, roomName) => {
    if (!socket) {
      return
    }
    socket.emit('accept undo', { groupName, roomName })
  }

  const denyUndo = (groupName, roomName) => {
    if (!socket) {
      return
    }
    socket.emit('deny undo', { groupName, roomName })
  }

  const chatMessage = (groupName, roomName, message) => {
    if (!socket) {
      return
    }
    socket.emit('chat message', { groupName, roomName, message })
  }

  const groupChatMessage = (groupName, message) => {
    if (!socket) {
      return
    }
    socket.emit('group chat message', { groupName, message })
  }

  const lock = (groupName, roomName, password) => {
    var cipher
    if (!socket) {
      return
    }
    if (password) {
      cipher = CryptoJS.AES.encrypt(password, CRYPT_KEY).toString()
    }
    socket.emit('lock', { groupName, roomName, cipher })
  }

  const unlock = (groupName, roomName) => {
    if (!socket) {
      return
    }
    socket.emit('unlock', { groupName, roomName })
  }
  
  const isOwner = (groupName, roomName) => {
    if (groupName && roomName) {
      let foundRoom = state.rooms ? state.rooms.find(room => room.groupName === groupName && room.name === roomName) : undefined
      if (!foundRoom) {
        return false
      }
      return Boolean(
        settingsContext.userSettings !== undefined &&
        foundRoom.owner !== undefined &&
        settingsContext.userSettings.userName === foundRoom.owner.userName
      )
    }
    else {
      return Boolean(
        settingsContext.userSettings !== undefined &&
        state.room.owner !== undefined &&
        settingsContext.userSettings.userName === state.room.owner.userName
      )
    }
  }

  const isPlayer = (groupName, roomName) => {
    if (groupName && roomName) {
      let foundRoom = state.rooms ? state.rooms.find(room => room.groupName === groupName && room.name === roomName) : undefined
      if (!foundRoom) {
        return false
      }
      return Boolean(
        settingsContext.userSettings !== undefined &&
        (
          (
            foundRoom.player1 !== undefined &&
            foundRoom.player1.userName === settingsContext.userSettings.userName
          ) ||
          (
            foundRoom.player2 !== undefined &&
            foundRoom.player2.userName === settingsContext.userSettings.userName
          )
        )
      )
    }
    else {
      return Boolean(
        settingsContext.userSettings !== undefined &&
        state.room.owner !== undefined &&
        settingsContext.userSettings.userName === state.room.owner.userName
      )
    }
  }

  const isLocked = (groupName, roomName) => {
    if (groupName && roomName) {
      let foundRoom = state.rooms ? state.rooms.find(room => room.groupName === groupName && room.name === roomName) : undefined
      return foundRoom ? Boolean(foundRoom.lock) : false
    }
    else {
      return state.room ? Boolean(state.room.lock) : false
    }
  }

  const closeRequestPasswordDialog = () => {
    dispatch({ type: types.game.CLOSE_REQUEST_PASSWORD_DIALOG })
  }

  const sortUsers = (a, b) => {
    if (a.userName && !b.userName) {
      return -1
    }
    else if (!a.userName && b.userName) {
      return 1
    }
    else if (a.userName && b.userName) {
      if (a.userName < b.userName) {
        return -1
      }
      else if (a.userName > b.userName) {
        return 1
      }
      else {
        return 0
      }
    }
    else if (!a.userName && !b.userName) {
      if (a.displayName < b.displayName) {
        return -1
      }
      else if (a.displayName > b.displayName) {
        return 1
      }
      else {
        return 0
      }
    }
  }

  const getGroup = () => {
    var targetGroup
    if (state.groups.length > 0) {
      targetGroup = state.groups.find(group => group.name === urlGroupName)
      return targetGroup ? targetGroup : undefined
    }
    return undefined
  }

  const getGroupUsers = () => {
    if (state.group && state.group.users && state.group.users.length > 0) {
      return state.group.users.sort(sortUsers)
    }
    return []
  }

  const getRoomUsers = () => {
    if (state.room && state.room.users && state.room.users.length > 0) {
      return state.room.users.sort(sortUsers)
    }
    return []
  }

  const getGroupChat = (groupName) => {
    if (state.groupChat && state.groupChat.length > 0) {
      return state.groupChat.filter(message => message.groupName === groupName)
    }
    return []
  }

	const makeURL = (messageId) => {
		var message = state.chat.messages[messageId]
		
		var foundCard, card, url, winner, moves
		if (message.type === constants.CHAT_TYPE.GAME_RESULT) {
			foundCard = renjuBoardCards.cards.find(card => card.groupName === message.groupName && card.roomName === message.roomName)
			if (!foundCard) {
				return
			}
			card = deepCopy(foundCard)
			card.settings.isVisibleGameInfo = true
			card.settings.isVisibleTitle = true
			card.settings.isVisiblePlayerName = true
			card.settings.isVisibleGameResult = true
			card.gameInfo.blackPlayerName =
				message.gameResult.player1.color === constants.stoneType.BLACK ? message.gameResult.player1.displayName :
				message.gameResult.player2.color === constants.stoneType.BLACK ? message.gameResult.player2.displayName : ''
			card.gameInfo.whitePlayerName =
				message.gameResult.player1.color === constants.stoneType.WHITE ? message.gameResult.player1.displayName :
				message.gameResult.player2.color === constants.stoneType.WHITE ? message.gameResult.player2.displayName : ''
			moves = card.moves.filter(move => move.number > 0)
			card.gameInfo.gameEndNumber = moves.length === 0 ? '' : `${moves[moves.length - 1].color}-${moves[moves.length - 1].number}`
			switch (message.gameResult.action) {
				case constants.ENDED_ACTION.FIVE:
					winner =
						message.gameResult.user.userName === message.gameResult.player1.userName ? message.gameResult.player1 :
						message.gameResult.user.userName === message.gameResult.player2.userName ? message.gameResult.player2 : undefined
					card.gameInfo.gameResult =
						winner && winner.color === constants.stoneType.BLACK ? 'BlackWin' :
						winner && winner.color === constants.stoneType.WHITE ? 'WhiteWin' : ''
					break
				case constants.ENDED_ACTION.RESIGN:
				case constants.ENDED_ACTION.TIMEOUT:
					winner =
						message.gameResult.user.userName === message.gameResult.player1.userName ? message.gameResult.player2 :
						message.gameResult.user.userName === message.gameResult.player2.userName ? message.gameResult.player1 : undefined
					card.gameInfo.gameResult =
						winner && winner.color === constants.stoneType.BLACK ? 'BlackWin' :
						winner && winner.color === constants.stoneType.WHITE ? 'WhiteWin' : ''
					break
				case constants.ENDED_ACTION.OFFER_DRAW:
					card.gameInfo.gameResult = 'Draw'
					break
				default:
					break
			}
			url = createURL(card, settingsContext.language)
      dispatch({ type: types.game.MAKE_URL, url, id: messageId })
		}
  }

  useEffect(() => {
    if (authentication.auth0 && !socket) {
      init()
    }
    return () => {
      if (socket) {
        socket.close()
      }
    }
  }, [authentication.auth0, socket])
  
  useEffect(() => {
    if (state.selectedGroup !== undefined && prevState.current.selectedGroup === undefined) {
      joinGroup(state.selectedGroup)
    }
    prevState.current = state
  }, [state.selectedGroup])

	useEffect(() => {
		if (socket && !isInitialized) {
			socket.on('disconnect', data => {
				console.dir(`disconnect ${data}`)
			})
			socket.on('server time', data => {
        dispatch({ type: types.game.RECEIVE_SERVER_TIME, data })
			})
			socket.on('groups', data => {
        dispatch({ type: types.game.RECEIVE_GROUPS, data })
      })
      socket.on('group', data => {
        dispatch({ type: types.game.RECEIVE_GROUP, data })
			})
			socket.on('create game room', data => {
				if (data.roomName !== '') {
          history.push(`/game/${data.groupName}/${data.roomName}`)
				}
			})
			socket.on('game rooms', data => {
        dispatch({ type: types.game.RECEIVE_GAME_ROOMS, data })
			})
			socket.on('game room', data => {
        dispatch({ type: types.game.RECEIVE_GAME_ROOM, data })
        dispatchForRedux({ type: types.game.RECEIVE_GAME_ROOM, data })
			})
			socket.on('chat message', data => {
				dispatch({ type: types.game.RECEIVE_CHAT_MESSAGE, data })
      })
			socket.on('group chat message', data => {
				dispatch({ type: types.game.RECEIVE_GROUP_CHAT_MESSAGE, data })
      })
      socket.on('request password', () => {
        dispatch({ type: types.game.REQUEST_PASSWORD })
      })
			setIsInitialized(true)
    }
  }, [socket, renjuBoardCards])

  var messages = state.chat.messages.length > 0 ? state.chat.messages.filter(message => message.groupName === urlGroupName && message.roomName === urlRoomName) : []
  messages.sort((a, b) => Boolean(a.datetime < b.datetime))
  const prevMessages = useRef(messages)
  useEffect(() => {
    if (
      prevMessages.current.length > 0 &&
      messages.length > prevMessages.current.length &&
      messages[messages.length - 1].type === constants.CHAT_TYPE.GAME_RESULT
    ) {
      makeURL(messages.length - 1)
    }

    prevMessages.current = messages
  }, [messages])

  return (
    <GameContext.Provider
      value={{
				init,
        clearChat,
        clearRoom,
				changedGroup,
				serverTime,
				groupsList,
				joinGroup,
				leaveGroup,
				joinRoom,
				leaveRoom,
				joinGame,
				leaveGame,
				restartGame,
				newGame,
				gameSettings,
				resetGameSettings,
				ready,
				createGameRoom,
				move,
				resign,
				offerDraw,
				acceptDraw,
				denyDraw,
				offerUndo,
				acceptUndo,
				denyUndo,
        chatMessage,
        groupChatMessage,
        lock,
        unlock,
        closeRequestPasswordDialog,
        isOwner,
        isPlayer,
        isLocked,
        getGroup,
        getGroupUsers,
        getRoomUsers,
        getGroupChat,
        makeURL,
        setUrlGroupName,
        setUrlRoomName,
        setOpenNewGameSettingsDialog,
				socket,
				diffTime: state.diffTime,
        rooms: state.rooms,
        room: state.room,
        groups: state.groups,
        group: state.group,
				selectedGroup: state.selectedGroup,
        chat: state.chat,
        groupChat: state.groupChat,
        requestPasswordDialog: state.requestPasswordDialog,
        urlGroupName,
        urlRoomName,
        openNewGameSettingsDialog
      }}
    >
      {children}
    </GameContext.Provider>
  )
}











// WEBPACK FOOTER //
// ./src/Pages/Game/GameProvider.js